module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/new/gronk_imagem-c5bf35b358058395e3777b02d4334238.jpg";